// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_Ypj","cls2":"Comments-cls2_PGk Comments-cls1_Ypj"};